<project-details-default-header [project]="project"></project-details-default-header>
<div class="custom-forms-section box_default box_white" [ngClass]="{'with-overlay': leavingModal}">
    <core-layout-modal-feedback class="modal-feedback" *ngIf="leavingModal"
        [type]="'warning'"
        [message]="'Discard Form Changes'"
        [text]="'You have not saved all your form values yet. Are you sure you want to leave and discard your changes?'"
        [buttonText]="'Discard'"
        [secondButtonText]="'Go Back'"
        (action)="onDiscard($event)"
        (secondButtonAction)="onStay($event)"
    ></core-layout-modal-feedback>

    <header>
        <h3>FORMS</h3>
    </header>

    <!-- PROJECT forms with access check-->
    <article *ngIf="accessForms; else noFormsAccess" class="custom-forms-section-main">

        <project-details-forms-list 
            [project]="project" 
            [user]="user"
        ></project-details-forms-list>
    </article>

    <ng-template #noFormsAccess> 
        <div class="no-access-error">
            <core-helpers-box-alert-message-icon 
                [text]="'You don’t have permission to see this section'"
                [icon]="'alert'"
            ></core-helpers-box-alert-message-icon>
        </div>
    </ng-template> 

</div>